import { useAppMutation } from "../../../http/useAppMutation.ts";

export const useUndeleteAssetOnBoard = ({
  boardUuid,
}: {
  boardUuid: string;
}) => {
  const mutation = useAppMutation({
    path: "assets/undelete",
    invalidate: [`boards/${boardUuid}/assets`],
  }).mutation;

  return {
    mutate: mutation.mutate,
    isLoading: mutation.isLoading,
  };
};
